import { RevisionFormData } from 'components/forms/revision/fill-out/types';
import { IStoredFile } from 'components/forms/revision/fill-out/fields/RevisionFieldFileList';
import { IForm } from 'pages/revisions-module/template-editor/editors/form/types';

export interface AttachmentFile {
  fileId: string;
  fileName: string;
  device?: string;
  location: string;
}

/** Collect the attachment sources displayed in revision and form detail. */
export function collectRevisionAttachments(
  revisionData: RevisionFormData,
  revisionForm: IForm | null
): AttachmentFile[] {
  const inputs = new Map(
    revisionForm?.sections
      .flatMap((section) => section.rows)
      .flatMap((row) => row.inputs)
      .filter((input) => input.spec.type === 'fileList')
      .map((input) => [input.spec.name, input]) ?? []
  );
  const files: AttachmentFile[] = [];

  // Directly iterate over the fields to get stored files
  Object.entries(revisionData.fields)
    .filter(([fieldName]) => inputs.has(fieldName))
    .forEach(([fieldName, storedFiles]: [string, IStoredFile[]]) => {
      const inputSpec = inputs.get(fieldName)!;

      storedFiles.forEach((storedFile) => {
        files.push({
          fileId: storedFile.fileId,
          fileName: storedFile.fileName,
          location: inputSpec.spec.label,
        });
      });
    });

  // Iterate over devices and look for attachments in fields
  Object.values(revisionData.devices).forEach((device) => {
    Object.entries(device.fields)
      .filter(([fieldName]) => inputs.has(fieldName))
      .forEach(([fieldName, storedFiles]: [string, IStoredFile[]]) => {
        const inputSpec = inputs.get(fieldName)!;

        storedFiles.forEach((storedFile) => {
          files.push({
            fileId: storedFile.fileId,
            fileName: storedFile.fileName,
            device: device.fields._deviceName,
            location: inputSpec.spec.label,
          });
        });
      });

    device.faults.forEach((fault) => {
      (fault.attachments || []).forEach((attachment) => {
        files.push({
          fileId: attachment.fileId,
          fileName: attachment.fileName,
          device: device.fields._deviceName,
          location: 'Nedostatky',
        });
      });
    });

    Object.entries(device.measurements).forEach(([sectionId, measurements]) => {
      const section = revisionForm?.sections.find((sec) => sec.id === sectionId);

      measurements.forEach((measurement) =>
        measurement._faults.forEach((fault) => {
          (fault.attachments || []).forEach((attachment) => {
            files.push({
              fileId: attachment.fileId,
              fileName: attachment.fileName,
              device: device.fields._deviceName,
              location: `Nedostatky na meraní ${section?.name}`,
            });
          });
        })
      );
    });
  });

  return files;
}
